import Currency from 'views/currency/Currency.container';

export default Currency;